import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { menuItems } from '../../utils/menuItems';
import * as docs from '../../utils/getDocuments';

const SearchBar = () => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const searchRef = useRef(null);
  const navigate = useNavigate();

  // Close results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    const val = e.target.value;
    setQuery(val);

    if (val.length < 2) {
      setResults([]);
      setShowResults(false);
      return;
    }

    const filteredMenus = [];
    const flattenMenu = (items, parentPath = "") => {
      items.forEach(item => {
        const fullPath = parentPath + item.path;
        if (item.text.toLowerCase().includes(val.toLowerCase())) {
          filteredMenus.push({
            title: item.text,
            path: item.target ? item.path : fullPath,
            target: item.target,
            category: 'Menú'
          });
        }
        if (item.submenu) {
          flattenMenu(item.submenu, fullPath);
        }
      });
    };
    flattenMenu(menuItems);

    const filteredDocs = [];
    Object.keys(docs).forEach(key => {
      if (Array.isArray(docs[key])) {
        docs[key].forEach(doc => {
          if (doc.title && doc.title.toLowerCase().includes(val.toLowerCase())) {
            filteredDocs.push({
              title: doc.title,
              path: doc.path,
              target: '_blank',
              category: 'Documento'
            });
          }
        });
      }
    });

    setResults([...filteredMenus, ...filteredDocs].slice(0, 10));
    setShowResults(true);
  };

  const handleItemClick = () => {
    setQuery('');
    setShowResults(false);
  };

  return (
    <div className="tp-header-search-wrapper" ref={searchRef}>
      <input
        type="text"
        className="tp-header-search-input"
        placeholder="Buscar en la web..."
        value={query}
        onChange={handleSearch}
        onFocus={() => query.length >= 2 && setShowResults(true)}
      />
      <i className="fal fa-search tp-header-search-icon"></i>

      {showResults && results.length > 0 && (
        <div className="tp-header-search-results">
          {results.map((item, index) => (
            <React.Fragment key={index}>
              {index === 0 || results[index-1].category !== item.category ? (
                <div className="tp-header-search-category">{item.category}</div>
              ) : null}
              <Link
                to={item.path}
                target={item.target}
                className="tp-header-search-result-item"
                onClick={handleItemClick}
              >
                <h6>{item.title}</h6>
                <span>{item.target ? 'Abrir enlace' : 'Ir a página'}</span>
              </Link>
            </React.Fragment>
          ))}
        </div>
      )}
      {showResults && results.length === 0 && (
        <div className="tp-header-search-results">
          <div className="tp-header-search-result-item text-center">
            <h6>No se encontraron resultados</h6>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
